module.exports = __webpack_public_path__ + "eco_chat.c4194403.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chatsuite/eco_chat.svg
// module id = 3023
// module chunks = 0